import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SFTPDTO  {
    _originalTypeClassName = "zERP.BO.SFTPDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SFTPDTO.translate = translateService;
}
this.SFTPDTOKey = null;
this._key = this.SFTPDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
private _SFTPDTOKey:any;
get SFTPDTOKey(): any {
    return this._SFTPDTOKey;
  }
set SFTPDTOKey(value: any) {
    this._SFTPDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SFTPDTOKey == null || $this.SFTPDTOKey == 0;
            }


}